import { atom } from 'recoil';
import defaultPPEs from 'ProjectManager/Project/Introductions/Create/recoil/ppes/defaultPPEs';

const ppesAtom = atom({
    key: 'projectManagement_introduction_create_ppes',
    default: defaultPPEs,
});

export default ppesAtom;
